import BaseLogicCallbacks from "@/lib/models/base-logic-callbacks";
import selectElementsBySelector from "@/lib/helpers/select-elements-by-selector";
import flowManager from "@/lib/services/flow-manager";
import FIELD_NAMES from "@/forms/constants/field-names";
import STEP_NAMES from "@/forms/constants/step-names";
import FIELDSET_NAMES from "@/forms/constants/fieldset-names";
import FORM_NAMES from "@/forms/constants/form-names";
import router from "@/router";
import otpService from "@/forms/api/services/otp";
import otpServiceReferal from "@/forms/api/services/otp-referral";
import formService from "@/forms/api/services/form";
import decisionService from "@/forms/api/services/decision";
import creditScoreService from "@/forms/api/services/credit-score";
import store from "@/store";
import getValueByFieldName from "@/forms/helpers/get-value-by-field-name";
//BEGIN code modified by ATTRA
import cifService from "@/forms/api/services/cif";
import cifUpdate from "@/forms/api/services/cif-update";
import leadCreationService from "@/forms/api/services/lead-creation";
import incomeUpdateService from "@/forms/api/services/income-update";
import workEmailValidationServive from "@/forms/api/services/work-email-validate";
import personalEmailValidationServive from "@/forms/api/services/personal-email-validate";
import creditScoreCalculationService from "@/forms/api/services/creidt-score-calculation";
import creditReportService from "@/forms/api/services/credit-report";
import srCreateService from "@/forms/api/services/sr-create";
import leadSquardedService from "@/forms/api/services/lead-squarded";
import appianPersonalInfoService from "@/forms/api/services/appian-personal-info";
import appianIncomeInfoService from "@/forms/api/services/appian-income-info";
import appianIdentityInfoService from "@/forms/api/services/appian-identity-info";
import appianEmpinfoService from "@/forms/api/services/appian-emp-info";
import createAddressService from "@/forms/api/services/create-address";
import accuityService from "@/forms/api/services/accuity";
import creditCCScoreService from "@/forms/api/services/credit-cc-score";
import insuranceService from "@/forms/api/services/insurance";
import customerExistService from "@/forms/api/services/customer-exist";
import referarlDataService from "@/forms/api/services/referral-data";
import crmContactValidationService from "@/forms/api/services/crm-contact-validation";
import accuitySupplementaryService from "@/forms/api/services/accuity-supplementary";
import emailNotificationService from "@/forms/api/services/email-notification";
import merchantNotificationService from "@/forms/api/services/merchant-notification";
//END
import monthlyInstalmentService from "@/forms/api/services/monthly-instalment";
import transactionService from "@/forms/api/services/transaction";
//SERVICE
import bankPerfioService from "@/forms/api/services/bank-perfio";
import bankPerfioService2 from "@/forms/api/services/bank-perfio-2";
import bankPerfioService3 from "@/forms/api/services/bank-perfio-3";

import routeManager from "@/router";
import basicEligibility from "@/forms/helpers/basic-eligibility";
import sendGAEvent from "@/forms/helpers/ga-events";

import {
  STEP_HOOK_BLOCKER,
  CREDIT_NOT_APPROVED_TITLE,
  NOT_ELIGIBLE_MESSAGE,
  NOT_ELIGIBLE,
  ELIGIBLE,
  NO_MONTHLY_INSTALMENTS_FROM_SERVER,
  TRANSACTION_NOT_STARTED,
  END_FORM,
  DECISION_FORM_MAP,
  CREDIT_NOT_APPROVED_TITLE_SALES,
  NOT_ELIGIBLE_MESSAGE_SALES
} from "@/forms/constants/onboarding-logic";
import { PERFIOS_ERROR_MESSAGE } from "@/lib/constants/validations";

import {
  SET_IS_PERFIOS_ERROR,
  SET_PERFIOS_ERROR_MESSAGE,
  SET_STP_CARD_INCOME_NEXT,
  SET_CIF_ERROR,
  SET_CIF_ERROR_COUNT,
  SET_ADDRESS_COUNT,
  CHANGE_VALUE_FIELD,
  SET_LIMIT_EXCEEDED
} from "@/lib/constants/mutations";
import formNames from "../constants/form-names";
//var path = window.location.href;
const SELECTOR_TO_BLOCK = [
  [STEP_NAMES.eligibility, FIELDSET_NAMES.fullName, FIELD_NAMES.firstName],
  [STEP_NAMES.eligibility, FIELDSET_NAMES.bornDate],
  [STEP_NAMES.contact, FIELDSET_NAMES.email],
  [STEP_NAMES.insuranceType, FIELD_NAMES.insuranceType]
];

const STEPS_TO_CLEAR_HISTORIC = [STEP_NAMES.employment];

const focusStep = form => {
  const stepElement = form.steps.find(element => element.$rendererComponent);

  stepElement.$rendererComponent.$el.focus();
};

const scrollToTop = () => window.scrollTo(0, 0);

/* eslint no-empty-pattern: "off" */
/* eslint no-empty-function: "off" */
/* eslint class-methods-use-this: "off" */

class DuniaLogicCallbacks extends BaseLogicCallbacks {
  constructor({
    finishCallback,
    onServiceErrorCallback,
    onServiceCallback,
    onConditionFailedCallback
  }) {
    super();
    this.finishCallback = finishCallback;
    this.onServiceCallback = onServiceCallback;
    this.onServiceErrorCallback = onServiceErrorCallback;
    this.onConditionFailedCallback = async data => {
      await this.persistStep(flowManager.currentStep);
      return onConditionFailedCallback(data);
    };
  }

  async onInitForm({ firstStep }) {
    const { appId } = flowManager.$store.state;
    if (appId) {
      this.persistStepWithoutBlocking();
    }

    // if (
    //   firstStep.name === STEP_NAMES.loanReviewConfirmation
    //   || firstStep.name === STEP_NAMES.creditCardLimitReview
    // ) {
    //   await monthlyInstalmentService.getMonthlyInstalment(
    //     firstStep,
    //     this,
    //   );
    // }

    firstStep.component.$nextTick().then(() => {
      scrollToTop();
    });
  }

  async finishForm(currentStep) {
    const { values } = store.state.formData;
    const { productType } = store.state;
    const channel = getValueByFieldName(values, FIELD_NAMES.channel);
    const primaryAddress = getValueByFieldName(values, FIELD_NAMES.primaryAddress);
    const homeAddress = getValueByFieldName(values, FIELD_NAMES.homeAddress);
    const isFormPersisted = await this.persistStep(currentStep);
    if (!isFormPersisted) {
      return {
        finishedForm: false
      };
    }

    if (currentStep.name === STEP_NAMES.incomeVerification) {
    }

    if (currentStep.name === STEP_NAMES.IbanVerification) {
      await workEmailValidationServive.workEmailValidate(currentStep, this);

      await incomeUpdateService.incomeUpdate(currentStep, this);
      //Commented on 17th Nov
      //await srCreateService.srCreate(currentStep, this);
      // const creditCCScoreStatus=await creditCCScoreService.creditCCScore(currentStep,this);
      const userAcceptance = await creditScoreCalculationService.creditScoreCalculation(
        currentStep,
        this
      );
      let incomeInfoResponse;
      //if ((productType === 'Personal_Loan' && path.includes('stp-loan')) || (productType === 'Credit Card' && path.includes('stp-card')) || (productType === 'Credit Card' && path.includes('stp/sales')) || (productType === 'Credit Card' && path.includes('/credit-card/'))) {

      await this.persistStep(currentStep);
      incomeInfoResponse = await appianIncomeInfoService.appianIncomeInfo(currentStep, this);
      await this.persistStep(currentStep);
      console.log(incomeInfoResponse);
      sendGAEvent(currentStep.name, incomeInfoResponse);
      if (incomeInfoResponse) {
        routeManager.goToFormByName(
          DECISION_FORM_MAP[routeManager.currentFormName][incomeInfoResponse]
        );
      }
      // }
      else if (
        (productType === "Personal_Loan" && path.includes("/loan/")) ||
        (productType === "Credit Card" && path.includes("/credit-card-aggregator/"))
      ) {
        sendGAEvent(currentStep.name, userAcceptance);
        if (userAcceptance) {
          routeManager.goToFormByName(
            DECISION_FORM_MAP[routeManager.currentFormName][userAcceptance]
          );
        }
      }

      return {
        moveToNextStep: !!incomeInfoResponse,
        reasonToStay: "Error in AppianIncomeInfo api"
      };
    }
    // if (currentStep.name === STEP_NAMES.incomeVerificationReview || currentStep.name === STEP_NAMES.appointment ||
    //     currentStep.name === STEP_NAMES.creditCardLimitReview) {
    //     var addressCount = 0;
    //     console.log('create Address');
    //     if (channel || store.state.source === 'DSA' || store.state.source === 'Dsa' || store.state.source === 'dsa' || primaryAddress) {
    //         //  console.log('create Address')
    //         await createAddressService.createAddress(currentStep, this);
    //         await createAddressService.createAddress(currentStep, this);
    //         addressCount++;

    //     }
    // }

    if (currentStep.name === STEP_NAMES.supplementaryCard) {
      await this.persistStep(currentStep);
      // if (channel || store.state.source === 'DSA' || store.state.source === 'Dsa' || store.state.source === 'dsa' || primaryAddress) {
      //     // console.log('create Address')
      //     await createAddressService.createAddress(currentStep, this);
      //     await createAddressService.createAddress(currentStep, this);
      //     addressCount++;

      // }
      store.state.formData.supplementaryCards.forEach(element => {
        accuitySupplementaryService.accuitySupplementary(currentStep, element, this);
      });

      // shouldMove = true;
      // shouldMove = shouldMove && persistedStep;

      // if (!channel) {
      //     await leadSquardedService.leadSquarded(currentStep, this);
      // }
      // this.finishCallback();

      // return {
      //     finishedForm: true,
      // };
    }
    //iban step end

    if (!channel) {
      await leadSquardedService.leadSquarded(currentStep, this);
    }

    this.finishCallback();

    return {
      finishedForm: true
    };
  }

  decideNextStep({ currentStep, currentStepIndex, mainForm }) {
    const { customFlow } = currentStep;

    if (customFlow) {
      const triggeredFlowCase = customFlow.find(flowCase => flowCase.condition());

      if (triggeredFlowCase && triggeredFlowCase.goTo) {
        const stepToGo = mainForm.steps.find(step => step.name === triggeredFlowCase.goTo);

        return stepToGo;
      }
    }

    if (mainForm.steps.length === currentStepIndex + 1) {
      return false;
    }

    return mainForm.steps[currentStepIndex + 1];
  }

  async onStepChanged({ newStep }) {
    const { name: newStepName } = newStep;
    const { form } = newStep;

    if (newStepName === STEP_NAMES.feedbackThanks) {
      const elementsToBlock = selectElementsBySelector(SELECTOR_TO_BLOCK, form);
      elementsToBlock.map(s => s.addTransactionalBlocker(STEP_HOOK_BLOCKER));
    }

    if (STEPS_TO_CLEAR_HISTORIC.indexOf(newStepName) !== -1) {
      flowManager.setNewFirstStep();
    }

    // if (newStepName != STEP_NAMES.incomeVerification || newStepName != STEP_NAMES.eligibility || newStepName != STEP_NAMES.identityReview) {
    //   await this.persistStepWithoutBlocking();
    // }

    // TODO: The focus should be managed in ui, not here
    newStep.component.$nextTick().then(() => {
      focusStep(form);
      scrollToTop();
    });
  }

  async shouldGoToStep({ possibleStep, currentStep }) {
    const { values } = store.state.formData;
    const { form } = currentStep;
    const { customFlow } = currentStep;
    const { productType } = store.state;
    const channel = getValueByFieldName(values, FIELD_NAMES.channel);
    const primaryAddress = getValueByFieldName(values, FIELD_NAMES.primaryAddress);
    const addressTypeHome = getValueByFieldName(values, FIELD_NAMES.homeAddress);
    if (customFlow) {
      const triggeredFlowCase = customFlow.find(flowCase => flowCase.condition());

      // ToDo probably not needed anymore
      if (triggeredFlowCase && triggeredFlowCase.runAction) {
        triggeredFlowCase.runAction();
        return { moveToNextStep: false };
      }
    }

    let creditApproval = true;
    let shouldMove = true;
    let actionKey;
    let creditApprovalAppian;
    var count = 0;
    // if( currentStep.name === STEP_NAMES.insuranceType){

    //     sendGAEvent(currentStep.name, 'Deem | Insurance Application');
    //       routeManager.goToFormByName('Deem | Insurance Application',{
    //         stepNameToInit: 'welcome'
    //       });
    //   }

    // if (currentStep.name === STEP_NAMES.stpSales) {
    //     const persistedStep = await this.persistStep(currentStep);

    //     if (persistedStep) {
    //         shouldMove = await otpService.sendOtpCustomer(currentStep, this);
    //     }
    //     shouldMove = true;
    //     shouldMove = shouldMove && persistedStep;
    //     return {
    //         moveToNextStep: shouldMove,
    //     };
    // }

    if (form.name === FORM_NAMES.leadCapture && currentStep.name === STEP_NAMES.welcome) {
      const persistedStep = await this.persistStep(currentStep);
      this.finishCallback();
      return {
        finishedForm: true
      };
    }

    if (
      currentStep.name === STEP_NAMES.incomeVerificationReview ||
      currentStep.name === STEP_NAMES.appointment ||
      currentStep.name === STEP_NAMES.creditCardLimitReview
    ) {
      await this.persistStep(currentStep);
      // console.log('create Address');
      if (
        channel ||
        store.state.source === "DSA" ||
        store.state.source === "Dsa" ||
        store.state.source === "dsa" ||
        addressTypeHome
      ) {
        await createAddressService.createAddress(currentStep, this);
        // await createAddressService.createAddress(currentStep, this);
        // addressCount++;
      }
    }

    if (currentStep.name === STEP_NAMES.eligibility) {
      var path = window.location.href;
      await this.persistStep(currentStep);
      if (
        (productType === "Personal_Loan" && path.includes("/loan")) ||
        (productType === "Personal_Loan" && path.includes("stp-loan")) ||
        (productType === "Credit Card" && path.includes("stp-card")) ||
        (productType === "Credit Card" && path.includes("stp/sales")) ||
        (productType === "Credit Card" && path.includes("/credit-card/")) ||
        (productType === "Personal_Loan" && path.includes("stp-topup"))
      ) {
        //await this.persistStepWithoutBlocking();
        //await this.persistStep(currentStep);
        const personalInfoResponse = await appianPersonalInfoService.appianPersonalInfo(
          currentStep,
          this
        );
        await this.persistStep(currentStep);
        if (personalInfoResponse === "TECHNICAL ERROR") {
          routeManager.goToFormByName(
            DECISION_FORM_MAP[routeManager.currentFormName][personalInfoResponse]
          );
        }
      }
      // shouldMove = isCodeValidated;

      if (form.name === FORM_NAMES.eligibility) {
        const isEligible = basicEligibility(this, currentStep);

        if (!isEligible.moveToNextStep) {
          sendGAEvent(currentStep.name, NOT_ELIGIBLE);
          return isEligible;
        }
      }

      actionKey = ELIGIBLE;
    }
    if (currentStep.name === STEP_NAMES.continue) {
      console.log("we are in digital step 1");
      // flowManager.goToNextStep({
      //   stepToGo: this.STEP_NAMES.digitalChoice,
      //   skipValidations: true,
      // });
    }
    if (currentStep.name === STEP_NAMES.choice) {
      console.log("we are in step choice");
    }

    //Code added on 6th JAN 2020 to to  redirect from welcome step to personal info step without any error.
    // if (currentStep.name === STEP_NAMES.welcome) {
    //   await this.persistStepWithoutBlocking();
    //   if (form.name === FORM_NAMES.welcome) {
    //     const isEligible = basicEligibility(this, currentStep);

    //     if (!isEligible.moveToNextStep) {
    //       sendGAEvent(currentStep.name, NOT_ELIGIBLE);
    //       return isEligible;
    //     }
    //   }

    //   actionKey = ELIGIBLE;
    // }

    //Employment Step Start
    if (currentStep.name === STEP_NAMES.employment) {
      var path = window.location.href;
      //Transaction Start
      const { values } = store.state.formData;
      const modeOfReceived = getValueByFieldName(values, FIELD_NAMES.mediumOfReceive);
      // if (form.name === FORM_NAMES.eligibility) {
      //   const isEligible = basicEligibility(this, currentStep);

      //   if (!isEligible.moveToNextStep) {
      //     await this.persistStep(currentStep);
      //     sendGAEvent(currentStep.name, NOT_ELIGIBLE);
      //     return isEligible;
      //   }
      // }

      // actionKey = ELIGIBLE;
    }
    //Employment Step End
    if (creditApprovalAppian) {
      if (creditApprovalAppian === "FAILURE") {
        sendGAEvent(currentStep.name, NOT_ELIGIBLE);

        return {
          moveToNextStep: false,
          reasonToStay: NOT_ELIGIBLE,
          stopForm: true,
          onFail: () =>
            this.onConditionFailedCallback({
              title: CREDIT_NOT_APPROVED_TITLE(flowManager.$store.state.formData.values.firstName),
              subtitle: NOT_ELIGIBLE_MESSAGE,
              actions: [{ click: END_FORM, label: "Continue" }],
              name: NOT_ELIGIBLE
            })
        };
      }
    } else {
      if (!creditApproval) {
        if (store.state.employeeCodes) {
          let product = store.state.productType;
          let newProduct;
          let status = store.state.transactionStatus;

          if (product === "Personal_Loan") {
            newProduct = "Loan";
          } else if (product === "Credit Card") {
            newProduct = "Credit Card";
          }
          sendGAEvent(currentStep.name, NOT_ELIGIBLE);

          return {
            moveToNextStep: false,
            reasonToStay: NOT_ELIGIBLE,
            stopForm: true,
            onFail: () =>
              this.onConditionFailedCallback({
                title: CREDIT_NOT_APPROVED_TITLE_SALES(
                  store.state.creditScoreStatus,
                  flowManager.$store.state.formData.values.firstName
                ),
                subtitle: NOT_ELIGIBLE_MESSAGE_SALES(newProduct, store.state.cifnumber),
                actions: [{ click: END_FORM, label: "Continue" }],
                name: NOT_ELIGIBLE
              })
          };
        } else {
          sendGAEvent(currentStep.name, NOT_ELIGIBLE);

          return {
            moveToNextStep: false,
            reasonToStay: NOT_ELIGIBLE,
            stopForm: true,
            onFail: () =>
              this.onConditionFailedCallback({
                title: CREDIT_NOT_APPROVED_TITLE(
                  flowManager.$store.state.formData.values.firstName
                ),
                subtitle: NOT_ELIGIBLE_MESSAGE,
                actions: [{ click: END_FORM, label: "Continue" }],
                name: NOT_ELIGIBLE
              })
          };
        }
      }
    }

    sendGAEvent(currentStep.name, actionKey);

    return {
      moveToNextStep: shouldMove
    };
  }

  persistStep(currentStep) {
    return formService.sendFormData(currentStep, this);
  }

  persistStepWithoutBlocking() {
    return formService.sendFormWithoutBlock();
  }
}

export default DuniaLogicCallbacks;
